export default __webpack_public_path__ + "static/media/avatar_large.f4da559e.svg";